// extracted by mini-css-extract-plugin
export default {"todo":"Footer_todo__vrj+w","about":"Footer_about__QSXRB","darkMode":"Footer_darkMode__wnHBN"};